import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import {
  RegraTributariaAdmin,
  RegraTributariaRequest,
  RegraTributariaResponse,
} from "../../../domain/models/regra-tributaria";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteRegraTributaria implements RegraTributariaAdmin {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async listar(): Promise<RegraTributariaResponse[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async buscar(id: number): Promise<RegraTributariaResponse> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async criar(data: RegraTributariaRequest): Promise<RegraTributariaResponse> {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: data,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async atualizar(id: number, data: RegraTributariaRequest): Promise<RegraTributariaResponse> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: "put",
      body: data,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async remover(id: number): Promise<void> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}`,
      method: "delete",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.noContent:
        return;
      default:
        throw new UnexpectedError();
    }
  }

  async toggleAtivo(id: number): Promise<RegraTributariaResponse> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${id}/toggle-ativo`,
      method: "put",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }
}
